<template>
  <div>
    <pre class="pageDescription text-justify" v-if="pageData.contents[0].description">{{ pageData.contents[0].description }}</pre>

    <ArticleCard
      v-for="articleThumb in pageData.childEntries.rows"
      :key="articleThumb.id"
      :articleThumb="articleThumb"
    />
  </div>
</template>

<script>
import ArticleCard from "@/components/common/ArticleCard";

export default {
  props: ["pageData"],

  components: { ArticleCard }
};
</script>

